// Signing out, from the profile page: the one place it lives.

import { LOGIN_SITE_URL, navigateTo } from "@jkast90/kast-common/auth";
import { logger } from "@common/utils/logger";
import { signOutAndLeave } from "./userSession";

export async function logout(): Promise<void> {
  logger.auth("Logout initiated by user");

  const redirect = encodeURIComponent(window.location.origin);
  const logoutUrl = `${LOGIN_SITE_URL}/logout?redirect=${redirect}`;

  // The session revokes the refresh token at Cognito (so a copy of it stops
  // working; capped, never throws) and clears the tokens; then the user's
  // cached data, API history and reminders go, so the next person to sign
  // in here starts clean (the selected workspace is kept, under this
  // user's own key), and the page leaves for the login site's logout.
  await signOutAndLeave(() => {
    logger.auth("Redirecting to logout", { logoutUrl });
    navigateTo(logoutUrl, { replace: true });
  });
}
